<div *ngIf="!isHideOrderStatus">
    <table class="table" aria-describedby="service" aria-hidden="true">      
        <tbody>
            <ng-container *ngIf="serviceWithDocList.length > 0; else load_else">
                <tr *ngFor="let service of serviceWithDocList;">
                    <td class="show-service">{{service?.service}}</td>
                    <td class="show-price">
                        <ng-container *ngIf="!service.isHidePrice">{{service.price ?? '' | number:'1.2-2'}}</ng-container>
                    </td>
                    <td class="action-icon" *ngIf="customerDocumentUpload">
                        <span class="ico-div"></span> 
                        <button type="button" class="open" aria-label="Close"
                            (click)="OpenModel(service?.appointmentDemandId)"><em class="fa fa-upload"
                                ngbTooltip="{{'lblUploadDocument' | translate}}"
                                tooltipClass="custom-revert"></em></button>
                        <span class="ico-div"></span>
                        <button type="button" class="open" aria-label="Close" (click)="ViewDocument(service)">
                            <em class="fas fa-eye" ngbTooltip="{{'lblViewDocument' | translate}}"
                                tooltipClass="custom-revert"></em>
                            <span id="viewdoc" class="position-absolute translate-middle badge rounded-pill count">
                                {{service?.docCount}} </span>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td class="text-info p-2" colspan="3" style="border-top: none;">
                        <div class="right-allign-Price">
                            <em class="fas fa-info-circle fa-lg align-middle" style="vertical-align: middle;"></em>
                            <span translate class="ml-2 mr-2"
                                style="font-size: small;font-style: italic;">lblPriceIncludeTax</span>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <ng-template #load_else>
                <tr>
                    <td colspan="8" translate>lblNoRecordsFound</td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>

<div class="preloader" *ngIf="isHideOrderStatus">
    <img src="../../../../assets/images/StOrderLoading.gif" alt="">
</div>